// modulos
import { mapState, mapActions } from 'vuex';

import GuestPanel from '@/components/modal/guest-panel';
import PopUp from '@/components/modal/pop-up';
import Dashboards from '@/components/supplier/competition-dashboard/Dashboards';

import _ from 'lodash';
import {
    getSupplier,
    getOffersQueries,
    getEnterpriseOffersQueries,
    getAnonymousOffersQueries,
    getSubscription,
    changeInviteStatus,
    getExtraSlotOffers
    // getOffersOpportunitysQueries
} from '@/services';
import { getEngelinkAds, getPopUp, sendPopUpClicks, doNotShowPopUp} from '@/services/api/marketing';
import { getCookie, setCookie } from '@/services/cookie-service';
import { appendQueryString, getParameterByName } from '@/utils';
import { INVITATION_STATUS, KEYS } from '@/utils/constants';
import { getCompetitionPanelStates } from '@/utils';

export default {
    name: 'CompetitionDashboard',
    components: { GuestPanel, Dashboards, PopUp },
    data: () => ({
        supplierHasSubscription: true,
        supplierHasActiveSubscription: true,
        showSubscriptionPendingModal: false,
        showBannerPromo: false,
        showMPopUp: true,
        supplier: {},
        stateQuery: {
            value: ''
        },
        searchQuery: '',
        userRatingForm: {
            rating: '',
            message: ''
        },
        disableSendRating: false,
        states: [
            {
                label: 'Estado',
                value: ''
            },
            ...getCompetitionPanelStates()
        ],
        offers: [],
        offersOpportunity: [],
        isOffersOpportunity: false,
        filling: false,
        nextOffersPage: null,
        debounceFunction: () => {},
        loadingOffers: true,
        loadingMoreOffers: false,
        isSendingNotification: false,
        offersTotal: 0,
        subscription: {},
        resizeScreen: 0,
        stateSupplier: '',
        showGuestPanel: false,
        userMainTag: '',
        popUpData: {}
    }),
    metaInfo() {
        return {
            meta: [
                // Search Engine
                { name: 'description', content: 'Veja aqui todas as oportunidades para sua empresa' },
                { name: 'image', content: `${process.env.VUE_APP_STATIC_BASE_URL}/meta-image.jpeg` },
                // Schema.org for Google
                { itemprop: 'name', content: 'Painel de cotações' },
                { itemprop: 'description', content: 'Veja aqui todas as oportunidades para sua empresa' },
                { itemprop: 'image', content: `${process.env.VUE_APP_STATIC_BASE_URL}/meta-image.jpeg` },
                // Open Graph general (Facebook, Pinterest & Google+)
                { property: 'og:title', content: 'Painel de cotações' },
                { property: 'og:site_name', content: 'Engelink' },
                {
                    property: 'og:description',
                    content: 'Veja aqui todas as oportunidades para sua empresa'
                },
                { property: 'og:type', content: 'website' },
                { property: 'og:url', content: this.$route.fullPath },
                { property: 'og:locale', content: 'pt_BR' },
                { property: 'og:image', content: `${process.env.VUE_APP_STATIC_BASE_URL}/meta-image.jpeg` }
            ]
        };
    },
    created() {
        this.showBannerPromo = !this.isSupplier || !this.hasSubscription;
    },
    async mounted() {
        if (this.isSupplier) {
            await this.getSupplier();
            this.getSubscription();
        } else {
            const token = getParameterByName('token');
            if (token && token.length > 0) {
                this.changeStatus(INVITATION_STATUS.EMAIL_DECLINED, token);
            }
            const displayParameter = getParameterByName('tag');
            if (displayParameter) {
                this.searchQuery = this.getDisplayParameter(displayParameter);
            }
            this.debounceFunction = _.debounce(() => this.filterRequest(), 300);
        }
        const popUp = await getPopUp();
        this.popUpData = popUp
        if(Object.keys(this.popUpData).length) this.showMPopUp = false
    },
    methods: {
        ...mapActions('user', ['setEngelinkMarketingDashboard']),
        tabChangeAction(value) {
            this.offers = [];
            this.offersOpportunity = [];
            this.isOffersOpportunity = value;
            const resetFilter = this.resetFilters();
            resetFilter ? null : this.filterRequest();
            if (this.isOffersOpportunity && this.supplierData.engelinkMarketingVisualized) {
                this.setEngelinkMarketingDashboard();
            }
        },
        removeOpportunity(offerId) {
            if (this.subscription.canAccessCrmBenefit) {
                this.offers = this.offers.filter(({ id }) => offerId != id);
                this.offersTotal -= 1;
            }
        },
        async changeStatus(status, token) {
            const data = {
                status: status,
                token: token
            };
            await changeInviteStatus(data);
        },
        getDisplayParameter: function(displayParameter) {
            const tagDict = {
                autovistoria: 'Autovistoria',
                cftv: 'CFTV',
                'empresa-de-elevadores': 'Empresa de elevadores',
                'empresas-de-pintura': 'Empresas de pintura',
                'energia-solar': 'Energia Solar',
                impermeabilizacao: 'Impermeabilização',
                incendio: 'Incêndio',
                'instalacao-eletrica': 'Instalação Elétrica',
                'laudo-tecnico': 'Laudo Técnico',
                'limpeza-de-caixa-dagua': 'Limpeza de Caixa D’Água',
                'marmore-e-granito': 'Mármore e Granito',
                'pc-de-luz': 'PC de Luz',
                'recuperacao-de-fachada': 'Recuperação de Fachada',
                reforma: 'Reforma',
                'sindico-profissional': 'Síndico Profissional',
                terceirizacao: 'Terceirização'
            };
            return tagDict[displayParameter];
        },
        setMarketingCookies() {
            const googleClickId = getParameterByName('gclid');
            const googleClientId = this.getGoogleAnalyticsClientId();
            const utmAdFormat = getParameterByName('utm_ad_format');
            const utmCampaign = getParameterByName('utm_campaign');
            const utmContent = getParameterByName('utm_content');
            const utmMedium = getParameterByName('utm_medium');
            const utmSource = getParameterByName('utm_source');
            const utmTerm = getParameterByName('utm_term');
            setCookie('googleClickId', googleClickId, 1);
            setCookie('googleClientId', googleClientId, 1);
            setCookie('utmAdFormat', utmAdFormat, 1);
            setCookie('utmCampaign', utmCampaign, 1);
            setCookie('utmContent', utmContent, 1);
            setCookie('utmMedium', utmMedium, 1);
            setCookie('utmSource', utmSource, 1);
            setCookie('utmTerm', utmTerm, 1);
        },
        getGoogleAnalyticsClientId() {
            let cookie = getCookie(KEYS.GOOGLE_ANALYTICS);
            if (cookie) {
                cookie = cookie.split('.');
                return cookie[2] + '.' + cookie[3];
            }
            return '';
        },
        async getSubscription() {
            try {
                this.subscription = { isActive: false };
                try {
                    const { data, error } = await getSubscription();
                    if (!error) {
                        this.subscription = data;
                    }
                } catch (e) {
                    console.log(e);
                }
            } catch (error) {
                console.error(error);
            }
        },
        async filterRequest() {
            try {
                this.loadingOffers = true;
                let queriesStrings = '';

                if (this.searchQuery.trim().length > 3) {
                    queriesStrings = appendQueryString(queriesStrings, `search=${this.searchQuery}`);
                }
                if (this.stateQuery.value) {
                    queriesStrings = appendQueryString(
                        queriesStrings,
                        `competition__construction_state=${this.stateQuery.value}`
                    );
                }
                let dataResponse;
                // if (this.isOffersOpportunity) {
                //     const { data } = await getOffersOpportunitysQueries(queriesStrings);
                //     dataResponse = data;
                //     this.nextOffersPage = dataResponse.next;
                //     this.offersTotal = dataResponse.count;
                //     return (this.offersOpportunity = dataResponse.results);
                // }
                if (this.filling) {
                    queriesStrings = appendQueryString(queriesStrings, 'open=true');
                }
                if (this.isSupplier) {
                    const [enterprisesOffers, extraSlot, offers, campaign] = await Promise.all([
                        getEnterpriseOffersQueries(),
                        getExtraSlotOffers(),
                        getOffersQueries(queriesStrings),
                        getEngelinkAds(
                            `?state=${this.stateSupplierAds}&location=internal-panel&tag=${this.userMainTag}&device=${this.deviceCampaign}`
                        )
                    ]);
                    Object.assign(campaign.data, {
                        state: this.stateSupplier,
                        tag: this.userMainTag
                    });
                    dataResponse = await this.mergeOffers(enterprisesOffers, extraSlot, offers, campaign);
                } else {
                    let response = [];
                    const { data } = await getAnonymousOffersQueries(queriesStrings);
                    const firstCampaign = await getEngelinkAds(
                        `?state=${this.stateQuery.value ? this.stateQuery.value : ''}&location=external-panel&tag=${
                            this.userMainTag
                        }&device=${this.deviceCampaign}`
                    );
                    const secondCampaign = await getEngelinkAds(
                        `?state=${this.stateQuery.value ? this.stateQuery.value : ''}&location=external-panel&tag=${
                            this.userMainTag
                        }&device=${this.deviceCampaign}`
                    );
                    Object.assign(firstCampaign.data, {
                        state: this.stateQuery.value
                    });
                    Object.assign(secondCampaign.data, {
                        state: this.stateQuery.value
                    });

                    response = data;
                    if (response.results.length >= 20) {
                        response.results.splice(this.getRandomInt(0, 8), 0, firstCampaign.data);
                        response.results.splice(this.getRandomInt(12, response.results.length), 0, secondCampaign.data);
                    } else {
                        response.results.splice(this.getRandomInt(0, response.results.length), 0, firstCampaign.data);
                    }
                    dataResponse = response;
                }

                this.offers = dataResponse.results;
                this.nextOffersPage = dataResponse.next;
                this.offersTotal = dataResponse.count;
            } catch (error) {
                console.error(error);
            } finally {
                this.loadingOffers = false;
            }
        },
        async mergeOffers(enterprisesOffers, extraSlot, offers, campaign) {
            let dataResponse = {};
            dataResponse = enterprisesOffers.data;
            dataResponse.count += offers.data.count;
            dataResponse.next = offers.data.next;
            dataResponse.previous = offers.data.previous;
            dataResponse.results = dataResponse.results.concat(extraSlot.data.results);
            dataResponse.results = dataResponse.results.concat(offers.data.results);
            dataResponse.results = dataResponse.results.concat(campaign.data);
            return dataResponse;
        },
        async loadMoreOffers() {
            if (this.isSupplier) {
                try {
                    this.loadingMoreOffers = true;
                    const queriesParams = `?${this.nextOffersPage.split('?')[1]}`;
                    const { data } = await getOffersQueries(queriesParams);
                    const campaign = await getEngelinkAds(
                        `?state=${this.stateSupplierAds}&location=internal-panel&tag=${this.userMainTag}&device=${this.deviceCampaign}`
                    );
                    this.offers = this.offers.concat(data.results);
                    this.offers = this.offers.concat(campaign.data);
                    this.nextOffersPage = data.next;
                } catch (error) {
                    console.error(error);
                } finally {
                    this.loadingMoreOffers = false;
                }
            }
        },
        resetFilters() {
            const stateQuery = !!this.stateQuery.length || !!this.stateQuery.value;
            const resetFilter = stateQuery || this.searchQuery.length;
            this.searchQuery = '';
            this.stateQuery = '';
            this.filling = false;
            this.$refs.stateQuery.selectedValue = '';
            return !!resetFilter;
        },
        async getSupplier() {
            try {
                const data = await getSupplier();
                const supplier = data.length > 0 ? data[0] : undefined;
                this.stateSupplier = this.setStateSupplier(supplier.state);
                this.stateSupplierAds = supplier.state
                this.stateQuery = { value: this.stateSupplier };
                this.userMainTag = supplier.mainTag;
                this.supplier = supplier
                // Modal Engelink Materiais
                this.userId = supplier.id
                // setando no onesignal o id do user
                this.$OneSignal.setExternalUserId(supplier.user);
            } catch (error) {
                console.error(error);
            } finally {
                this.debounceFunction = _.debounce(() => this.filterRequest(), 300);
            }
        },
        setStateSupplier(state) {
            switch (state) {
                case 'RJ':
                    return state;
                case 'SP':
                    return state;
                default:
                    return '';
            }
        },
        openGuestPanel() {
            this.showGuestPanel = true;
        },
        getRandomInt(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min) + min);
        },
        async setViewedAds() {
            this.showMPopUp = true
            await sendPopUpClicks(this.popUpData.id)
        },
        async doNotShowAgain() {
            this.showMPopUp = true
            await doNotShowPopUp(this.popUpData.id)
        }
    },
    computed: {
        ...mapState('user', ['user']),
        ...mapState('user', ['supplierData']),
        hasSubscription() {
            return this.user.type ? this.user.type.hasSubscription : false;
        },
        showTabs() {
            return this.hasSubscription && this.isSupplier;
        },
        isSupplier() {
            return this.user.type ? this.user.type.isSupplier : false;
        },
        hasUser() {
            return this.user.key ? true : false;
        },
        dummyCards() {
            this.resizeScreen = window.innerWidth;
            const vue = this;
            window.addEventListener('resize', () => {
                vue.resizeScreen = window.innerWidth;
            });
            if (this.resizeScreen > 1366) {
                return 4 - (this.offers.length % 4);
            } else if (this.resizeScreen <= 1366 && this.resizeScreen > 768) {
                return 3 - (this.offers.length % 3);
            } else {
                return 0;
            }
        },
        disableInfiniteScroll: function() {
            return this.loadingOffers || this.loadingMoreOffers || !this.isSupplier || !this.hasMoreOffers;
        },
        totalOfOffers: function() {
            return this.offers.length;
        },
        hasMoreOffers: function() {
            return this.nextOffersPage != null;
        },
        deviceCampaign: function() {
            return window.innerWidth <= 768 ? 'mobile' : 'desktop';
        }
    },
    watch: {
        stateQuery: function() {
            this.debounceFunction();
        },
        filling: function() {
            this.debounceFunction();
        },
        searchQuery: function() {
            this.debounceFunction();
        }
    }
};
